<template>
  <v-container>
    <v-row dense>
      <v-col class="py-8" v-for="(room, i) in rooms" :key="i" cols="12">
        <v-card class="rounded-card" elevation="2">
          <v-row>
            <v-col cols="12" lg="4">
              <image-carousel
                :photos="room.photos"
                height="200"
                padding="pa-3"
              />
            </v-col>
            <v-col cols="12" lg="8">
              <texts :title="room.title" :subtitle="room.subtitle" />
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import ImageCarousel from "../ImageCarousel.vue";
import Texts from "./Texts.vue";

export default {
  components: { ImageCarousel, Texts },
  computed: {
    ...mapState(["rooms"])
  }
};
</script>

<style lang="scss" scoped>
.rounded-card {
  border-radius: 20px 0px;
}
</style>
